import { TextField, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { toDatePickerValue } from "../../helper/date";
import { SETTLEMENT_STYLES } from "../../style/styles";

export default function SettlementDateField({
  label,
  value,
  onChange,
  onOpen,
  onFocus,
  labelAdornment,
  disabled = false,
}) {
  return (
    <div className="w-full">
      <div className="mb-[6px] flex items-center gap-2">
        <Typography sx={SETTLEMENT_STYLES.fieldLabelInline}>{label}</Typography>
        {labelAdornment}
      </div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          value={toDatePickerValue(value)}
          onChange={onChange}
          onOpen={disabled ? undefined : onOpen}
          disabled={disabled}
          slotProps={{
            textField: {
              fullWidth: true,
              sx: SETTLEMENT_STYLES.datePickerTextField,
              onFocus: disabled ? undefined : onFocus,
            },
            openPickerButton: { sx: SETTLEMENT_STYLES.datePickerButton },
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
    </div>
  );
}
